import { ownerConstants, preAppConstants } from "store";

var initialState = {
	loading: false,
	error: null,
};

export function owner(state = initialState, action) {
	switch (action.type) {
		case preAppConstants.RESET_APPLICATION_STATE:
			return {
				...initialState,
			};
		case ownerConstants.SEND_OWNER_REQUEST:
			return {
				...state,
				loading: true,
			};
		case ownerConstants.SEND_OWNER_SUCCESS:
			return {
				...state,
				loading: false,
			};
		case ownerConstants.SEND_OWNER_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		default:
			return state;
	}
}
